module.exports = __webpack_public_path__ + "img/game_phone_pt.1563ec81.png";